import { useCallback } from 'react';
import { Condition } from 'client/voladeum/conditions/types';
import { condition_default } from 'ducks/condition/defaults';
import { selectIndicators } from 'ducks/indicators/selectors';
import { selectModal } from 'ducks/modals/selectors';
import { updateModal } from 'ducks/modals/slices';
import { Button } from 'framework/button';
import { Dropdown } from 'framework/dropdown';
import { Modal } from 'framework/modal';
import { useStrategyContext } from 'pages/context/StrategyContext';
import { useAppDispatch, useAppSelector } from 'store/hooks';

import cn from '../Modal.module.scss';

export const ManageConditionModal = () => {
  const dispatch = useAppDispatch();
  const voladeum_indicators = useAppSelector(selectIndicators);
  const { is_open, is_update } = useAppSelector(selectModal('condition_manage'));
  const {
    condition,
    updateCondition,
    setCondition,
    addStrategyTriggerCondition,
    replaceStrategyTriggerCondition,
  } = useStrategyContext();

  const onSubmit = () => {
    if (is_update) {
      replaceStrategyTriggerCondition(condition);
    } else {
      addStrategyTriggerCondition(condition);
    }
    onClose();
  };

  const onClose = useCallback(() => {
    setCondition({ ...condition_default });
    dispatch(updateModal({ key: 'condition_manage', data: { is_open: false, is_update: false } }));
  }, [dispatch, setCondition]);

  const onUpdate = useCallback(
    (entity: Partial<Condition>) => updateCondition(entity),
    [updateCondition]
  );

  const { measure, threshold } = condition;

  return (
    <Modal
      is_open={is_open}
      identifier="condition_manage"
      width="500px"
      onSubmit={onSubmit}
      onClose={onClose}
    >
      <Modal.Header onClose={onClose} dismiss>
        {is_update ? 'Update Condition' : 'Create Condition'}
      </Modal.Header>
      <Modal.Body>
        <div className={cn.row}>
          <Dropdown
            label="Measure *"
            option_key="indicator_name"
            value={measure.indicator_name}
            onSelect={(indicator) => onUpdate({ ...condition, measure: indicator })}
            options={voladeum_indicators}
          />
          <Dropdown
            label="Threshold *"
            option_key="indicator_name"
            value={threshold.indicator_name}
            onSelect={(indicator) => onUpdate({ ...condition, threshold: indicator })}
            options={voladeum_indicators}
          />
        </div>
        <div className={cn.row}>
          {/* <Dropdown
            label="Sizing Method *"
            options={voladeum_sizing_methods}
            option_key="sizing_method_name"
            value={sizing_method_name}
            onSelect={({ sizing_method_id, sizing_method_name }) =>
              onUpdate({
                sizing_method_id,
                sizing_method_name,
                position: 0,
                position_formatted: '0',
              })
            }
          />
          <SizingMethodInput
            label="Max Position *"
            value={position_formatted}
            onChange={({ float_value, formatted_value }) => {
              onUpdate({ position: float_value, position_formatted: formatted_value });
            }}
          /> */}
        </div>
      </Modal.Body>
      <Modal.Footer>
        <div className={cn.flex} />
        <Button type="submit">Ok</Button>
      </Modal.Footer>
    </Modal>
  );
};
